import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Modal, QrCode, Text } from '@vmos2/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean,
  onAfterRequestClose: Function,
  onRequestClose: Function,
  promotion?: {
    name: string,
    providerPromotion: {
      code: string,
    },
  },
};

export const UserPromotionQRModal = ({ isOpen, onAfterRequestClose, onRequestClose, promotion = {} }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation('profile.rewards');
  const { name, providerPromotion: { code } = {} } = promotion;

  return (
    <Modal
      isOpen={isOpen}
      onAfterRequestClose={onAfterRequestClose}
      onRequestClose={onRequestClose}
      stickToBottomOnMobile
      title={name}
    >
      <Text bold align="center" level={2} color={theme.color.black} mb={6}>
        {t('rewardsList.rewardsQRCode')}
      </Text>

      <QrCodeWrapper data-test="user-promotion-qr-modal-content">
        <QrCode border p={6} qrCodeContent={code} />

        <Text bold color={theme.color.black} level={1} mt={4} mb={1}>
          {code}
        </Text>
      </QrCodeWrapper>
    </Modal>
  );
};

const QrCodeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
